// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
  buttons: [
  // "slideShow",
  // "thumbs",
  // "zoom",
  // "fullScreen",
  // "share",
  "close"],
  loop: false,
  protect: true
});